import React, { Component } from "react";
import { findIndex } from "lodash";
import { Badge, Box, Flex, Text } from "@chakra-ui/react";
import { useTranslation, withTranslation } from "react-i18next";
import { chakraComponents } from "chakra-react-select";
import { defaultOptionsStyle } from "../../styled/details/stylesSelect";
import TldrChakraSelect from "../../common/TldrChakraSelect";

const Option = (props) => {
  const { t } = useTranslation(["navbar"]);
  return (
    <>
      <chakraComponents.Option {...props}>
        <Flex direction="column" align="flex-start">
          <Box>
            {props.children}
            {props.data.isNew && (
              <Badge
                bg="brand.primary"
                variant="solid"
                borderRadius="full"
                color="gray.900"
                ml={2}
              >
                {t("export_badge_new")}
              </Badge>
            )}
            {props.data.isBeta && (
              <Badge bg="brand.primary" variant="solid" color="gray.900" ml={2}>
                {t("export_badge_beta")}
              </Badge>
            )}
          </Box>
          <Text fontSize="12px" color="gray.300">
            {props.data.subtext}
          </Text>
        </Flex>
      </chakraComponents.Option>
    </>
  );
};

class TLDRDownloadFileType extends Component {
  constructor(props) {
    super(props);
    this.fileTypes = [
      {
        value: "png",
        label: "PNG",
        subtext: "High quality image",
      },
      {
        value: "jpeg",
        label: "JPG",
        subtext: "Small file size image",
      },
      {
        value: "mp4",
        label: "Video",
        subtext: "Build a quick video",
      },
      {
        value: "gif",
        label: "GIF",
        subtext: "Export as animated gif",
        isNew: true,
      },
      {
        value: "svg",
        label: "SVG",
        subtext: "Sharp vector graphics at any size",
        isBeta: true,
        isDisabled: false,
      },
    ];
  }

  render() {
    const { t } = this.props;
    const { fileType, isAnimatedStory, supportedFileTypes } = this.props;
    let valueIndex = findIndex(this.fileTypes, {
      value: fileType,
    });

    const svgOptionIndex = findIndex(this.fileTypes, {
      value: "svg",
    });

    this.fileTypes[svgOptionIndex] = {
      ...this.fileTypes[svgOptionIndex],
      isDisabled: isAnimatedStory,
    };

    const fileTypes = supportedFileTypes
      ? this.fileTypes.filter((item) => supportedFileTypes.includes(item.value))
      : this.fileTypes;

    return (
      <>
        {this.props.hideHeader ? null : (
          <Text fontSize="xs" casing="uppercase" fontWeight="bold" mb={2}>
            {t("download_as")}
          </Text>
        )}
        <TldrChakraSelect
          value={valueIndex > -1 ? fileTypes[valueIndex] : fileTypes[0]}
          defaultValue={fileTypes[0]}
          onChange={this.onChange}
          options={fileTypes}
          chakraStyles={defaultOptionsStyle}
          placeholder={t("file_type")}
          components={{ Option }}
        />
      </>
    );
  }

  onChange = (selectedValue) => {
    this.props.onFileTypeChange(selectedValue.value);
  };
}

TLDRDownloadFileType.propTypes = {};

export default withTranslation(["navbar"])(TLDRDownloadFileType);
